export default __webpack_public_path__ + "static/media/etherscan-logo-light-circle.b1f5454d.svg";